import React from 'react'
import './Plans.css'
import whiteTick from '../../assets/whiteTick.png'
import {plansData} from '../../data/plansData'

const Plans = () => {
  return (
    <div className="plains-container" id='plans'>
        <div className='blur plans-b-2'></div>
        <div className="blur plans-b-1"></div>
        <div className="programs-header" style={{gap: '2rem'}}>
            <span className='stroke-txt'>READY TO START</span>
            <span>YOUR JOURNEY</span>
            <span className='stroke-txt'>NOW WITH US</span>
        </div>
{/*Plans card*/}
        <div className="plans">
            {plansData.map((plan , i) =>(
                <div className="plan" key={i}>
                    {plan.icon}
                    <span>{plan.name}</span>
                    <span>{plan.price}</span>

                    <div className="features">
                        {plan.features.map((feature , i) =>(
                            <div className="feature">
                                <img src={whiteTick} alt="" />
                                <span key={i}>{feature}</span>
                            </div>
                        ))}
                    </div>
                    <div>
                        <span>See more Benefits --</span>
                    </div>
                    <button className="btn">JOIN NOW</button>
                </div>
            ))}
        </div>
    </div>
  )
}

export default Plans